<!-- Section Bidon Pompe -->
<app-collapse
  [title]="'P0003605.status.bidonPompe' | translate"
  [warning]="getValue('icSFinBidon') === 1"
>
  <div slot="contenu">
    @if (getValue('icIDetecteurFinBidonInstalle') === 1) {
      <app-display-rubrique-status-with-warning
        [title]="'P0003605.status.bidon' | translate"
        [warning]="getValue('icSFinBidon') !== 0"
        [icon]="'fa-exclamation-triangle'"
        [text]="'P0003605.status.ok' | translate"
      />

      @if (isSupportTechnique()) {
        <app-display-rubrique-status
          [title]="'P0003605.status.etatContact' | translate"
          [value]="
            getValue('icSEtatContactFinBidon') === 0
              ? ('P0003605.status.ferme' | translate)
              : ('P0003605.status.ouvert' | translate)
          "
        />
      }
    }

    <app-display-rubrique-status-on-off
      [title]="'P0003605.status.fonctionnementPompe' | translate"
      [value]="getValue('icSEtatPompe') !== 0"
    />
  </div>
</app-collapse>

<!-- Section Désinfection -->
<app-collapse
  [title]="'P0003605.status.desinfection' | translate"
  [warning]="
    getValue('icSVigilenceChlore') === 1 ||
    getValue('icSSecuriteDesinfection') === 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P0003605.status.arretDebit' | translate"
      [value]="
        getValue('icSArretInjection') === 0
          ? ('P00032.status.oui' | translate)
          : ('P00032.status.non' | translate)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003605.status.detectionDebit' | translate"
        [value]="
          getValue('icSDetectionDebitReference') === 0
            ? ('P0003605.status.indisponible' | translate)
            : getValue('icSDetectionDebitReference') === 1
              ? ('P0003605.status.absent' | translate)
              : ('P0003605.status.present' | translate)
        "
      />
    }

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P0003605.status.securiteSurdosage' | translate"
      [warning]="getValue('icSVigilenceChlore') === 1"
      [notWarning]="'-'"
      [ctaText]="'P0003605.status.securiteSurdosage.value' | translate"
      (onPress)="acknowledgeUtilisateur()"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-with-warning-and-cta
        [title]="'P0003605.status.nbrSecurite' | translate"
        [warning]="false"
        [notWarning]="getValue('icSNombreTotalProtectionSurdosage') + ''"
        [ctaText]="'P0003605.status.resetCompteur' | translate"
        (onPress)="resetCompteur()"
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P0003605.status.securiteDesinfection' | translate"
      [warning]="getValue('icSSecuriteDesinfection') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'-'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P0003605.status.autoFiltration' | translate"
        [value]="getValue('icSMiseEnRouteFiltration') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P0003605.status.mesureRX' | translate"
        [value]="
          getValue('icSMesureRxReferenceDisponible') === 0
            ? ('P0003605.status.indisponible' | translate)
            : ('P0003605.status.ok' | translate)
        "
      />
    }
  </div>
</app-collapse>

<!-- Section Produit -->
<app-collapse
  [title]="'P0003605.status.produit' | translate"
  [warning]="presenceProduit === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P0003605.status.connexionProduit' | translate"
      [warning]="presenceProduit !== 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P0003605.status.ok' | translate"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003605.status.nbrCommutation' | translate"
        [value]="getValue('icSNombreCommutationRelais') + ''"
      />

      <app-display-rubrique-status-on-off
        [title]="'P0003605.status.etatBtn' | translate"
        [value]="getValue('icSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P0003605.status.compteur' | translate"
        [value]="getValue('icSCompteurBouton') + ''"
      />
    }
  </div>
</app-collapse>
